'use strict';

/**
 * 引数のエラーメッセージを画面内のエラー表示領域に表示する。
 *
 * エラー表示領域は「.alert.alert-danger」セレクターで選択できる場所に対応する。
 *
 * @param {string[]} error - エラーメッセージを格納する配列
 */
function showError(error) {
    if (!Array.isArray(error)) {
        return;
    }
    const XStringUtils = require('sswd_base/util').XStringUtils;
    let message = '<ul>';
    error.forEach((elem) => {
        message += `<li>${XStringUtils.encodeHtml(elem)}</li>`;
    });
    message += '</ul>';
    const $alert = $('.alert.alert-danger');
    $alert.html(message);
    $alert.removeClass('d-none');
    // 上部にスクロールする
    require('base/components/scrollAnimate')();
}

/**
 * 画面内のエラー表示領域を隠す。
 *
 * エラー表示領域は「.alert.alert-danger」セレクターで選択できる場所に対応する。
 */
function hideError() {
    const $alert = $('.alert.alert-danger');
    $alert.addClass('d-none');
    $alert.html('');
}

module.exports = {
    showError,
    hideError,
};
